import { Field } from 'formik';
import { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useCheckoutState } from '../../utils/checkoutState';
import { getAssetUrl } from '../../utils/config';
import getAvailableDeliveryTypes from '../../utils/getAvailableDeliveryTypes';
import Paragraph from '../atoms/Paragraph';
import SubHeadline from '../atoms/SubHeadline';
import OptionsField from '../formik/OptionsField';
import { showNotification } from './Notifications';

const DeliveryOptions = ({ isLoading }: { isLoading?: boolean }) => {
  const {
    checkoutState: {
      orderOptions: { shipping: shippingOptions },
    },
  } = useCheckoutState();
  const { formatMessage } = useIntl();

  const options = shippingOptions
    ? getAvailableDeliveryTypes(shippingOptions).map(key => ({
        key,
        label: formatMessage({ id: `shipping.deliveryType.options.${key}` }),
        defaultIcon: getAssetUrl(`delivery/${key}.svg`),
        activeIcon: getAssetUrl(`delivery/${key}Active.svg`),
      }))
    : [];

  useEffect(() => {
    if (!options.length) {
      showNotification({
        level: 'info',
        text: formatMessage({ id: 'shipping.notifications.noDeliveryMethods' }),
        autoClose: true,
      });
    }
  }, []);

  if (!options.length) {
    return (
      <>
        <SubHeadline>
          <FormattedMessage id="shipping.deliveryType.headline" />
        </SubHeadline>
        <Paragraph>
          <FormattedMessage id="shipping.notifications.noDeliveryMethods" />
        </Paragraph>
      </>
    );
  }

  if (options.length === 1) {
    return null;
  }

  return (
    <>
      <SubHeadline>
        <FormattedMessage id="shipping.deliveryType.headline" />
      </SubHeadline>
      <Field
        name="deliveryType"
        className="delivery-options"
        isLoading={isLoading}
        component={OptionsField}
        options={options}
        dataTestIdPrefix="deliveryOptions"
      />
    </>
  );
};

export default DeliveryOptions;
